module.exports = __webpack_public_path__ + "static/media/rim-back-left.b21640df.svg";